module.exports = new __parcel__URL__("flow.a34d5157.ogg").toString();